(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-List-New"] && !Shopify.designMode) return;
  try {
    
  console.log('Carousel script loaded');
document.addEventListener('DOMContentLoaded', function() {
  const carouselWrappers = document.querySelectorAll('.collection-list-new-wrapper');

  carouselWrappers.forEach((wrapper) => {
    const carousel = wrapper.querySelector('.collection-list-carousel');
    const prevButton = wrapper.querySelector('.collection-list-navigation__prev');
    const nextButton = wrapper.querySelector('.collection-list-navigation__next');

    if (carousel && prevButton && nextButton) {
      const scrollAmount = carousel.offsetWidth;

      function scrollCarousel(direction) {
        carousel.scrollBy({
          left: direction * scrollAmount,
          behavior: 'smooth'
        });
      }

      prevButton.addEventListener('click', () => scrollCarousel(-1));
      nextButton.addEventListener('click', () => scrollCarousel(1));

      // Touch swiping for mobile
      let touchStartX = 0;
      let touchEndX = 0;

      carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      carousel.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        if (touchEndX < touchStartX) {
          scrollCarousel(1);
        } else if (touchEndX > touchStartX) {
          scrollCarousel(-1);
        }
      }, { passive: true });

      // Keyboard navigation
      carousel.setAttribute('tabindex', '0');
      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          scrollCarousel(-1);
        } else if (e.key === 'ArrowRight') {
          scrollCarousel(1);
        }
      });

      // Set uniform height for all items
      function setUniformHeight() {
        const items = carousel.querySelectorAll('.collection-list-item__content');
        let maxHeight = 0;

        // Reset heights
        items.forEach(item => item.style.height = 'auto');

        // Find the maximum height
        items.forEach(item => {
          const height = item.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        // Set all items to the maximum height
        items.forEach(item => item.style.height = `${maxHeight}px`);
      }

      // Call setUniformHeight on load and resize
      setUniformHeight();
      window.addEventListener('resize', setUniformHeight);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
